import { render } from "./CreateDetail.vue?vue&type=template&id=bc260de0"
import script from "./CreateDetail.vue?vue&type=script&lang=js"
export * from "./CreateDetail.vue?vue&type=script&lang=js"

import "./CreateDetail.vue?vue&type=style&index=0&id=bc260de0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__